import { useQuery } from "@tanstack/react-query";
import { getComputeEfficiency } from "@/helpers/apis";
import { SkuCostParams } from "../types";

export const useComputeEfficiency = (params: SkuCostParams, enabled = true) => {
  return useQuery({
    queryKey: [
      "databricks-compute-efficiency",
      params.start_date,
      params.end_date,
      params.workspace_id,
    ],
    queryFn: () => getComputeEfficiency(params),
    enabled,
  });
};
